import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import myImg from "../../Assets/sai.png";
import Tilt from "react-parallax-tilt";
import { AiFillGithub, AiFillInstagram } from "react-icons/ai";
import { FaLinkedinIn } from "react-icons/fa";
import { SiMedium } from "react-icons/si";

function Home2() {
  return (
    <Container fluid className="home-about-section" id="about">
      <Container>
        <Row>
          <Col md={3} className="myAvtar">
            <Tilt>
              <img src={myImg} className="img-fluid" alt="avatar" />
            </Tilt>
          </Col>
          <Col md={9} className="home-about-description">
            <h1 style={{ fontSize: "2.6em" }}>
              LET ME <span className="purple"> INTRODUCE </span> MYSELF
            </h1>
            <p className="home-about-body">
              I'm a{" "}
              <span className="purple">Generative AI Engineer</span> with 5+
              years of experience shipping production systems — from LLM
              pipelines to high-throughput trading platforms.
              <br />
              <br />
              Currently at{" "}
              <i>
                <b className="purple">Kroger (Fortune 25)</b>
              </i>
              , I build GenAI data pipelines with{" "}
              <span className="purple">LangChain and GPT-4o</span> that power
              real retail operations. I also created{" "}
              <a
                href="https://voycee.com"
                target="_blank"
                rel="noreferrer"
                className="purple"
                style={{ textDecoration: "underline", fontWeight: "bold" }}
              >
                Voycee
              </a>{" "}
              — a <span className="purple">Voice AI platform</span> that
              automates restaurant and hospital calls in English and Spanish.
              <br />
              <br />
              Previously, I built the{" "}
              <span className="purple">
                AI scheduling engine at TeamCal AI
              </span>{" "}
              and worked on high-throughput{" "}
              <span className="purple">trading systems at DriveWealth</span>. My
              stack spans{" "}
              <span className="purple">
                React, TypeScript, Spring Boot, Python, LangChain, and AWS
              </span>
              .
              <br />
              <br />I hold an{" "}
              <span className="purple">
                M.S. in Computer Science from Pace University
              </span>{" "}
              and am{" "}
              <span className="purple">
                AWS Certified Developer – Associate
              </span>
              .
            </p>
          </Col>
        </Row>
        <Row>
          <Col md={12} className="home-about-social">
            <p>
              Feel free to <span className="purple">connect </span>with me
            </p>
            <ul className="home-about-social-links">
              <li className="social-icons">
                <a
                  href="https://github.com/saitata7"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour home-social-icons"
                >
                  <AiFillGithub />
                </a>
              </li>
              <li className="social-icons">
                <a
                  href="https://www.linkedin.com/in/saitata"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour home-social-icons"
                >
                  <FaLinkedinIn />
                </a>
              </li>
              <li className="social-icons">
                <a
                  href="https://medium.com/@saitata7"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour home-social-icons"
                >
                  <SiMedium />
                </a>
              </li>
              <li className="social-icons">
                <a
                  href="https://www.instagram.com/sai_tata.007"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour home-social-icons"
                >
                  <AiFillInstagram />
                </a>
              </li>
            </ul>
          </Col>
        </Row>
      </Container>
    </Container>
  );
}
export default Home2;
